export default "__VITE_IMAGE_ASSET__df9d6f2d__";